import React from 'react';

export const FullScreenContext = React.createContext({
	onClickFullScreen: () => ({}),
	fullScreen: false,
	isFullScreenEnabled: false,
});
